import { render } from "./HeroSectionComponent.vue?vue&type=template&id=4d9cb06a&scoped=true"
import script from "./HeroSectionComponent.vue?vue&type=script&lang=js"
export * from "./HeroSectionComponent.vue?vue&type=script&lang=js"

import "./HeroSectionComponent.vue?vue&type=style&index=0&id=4d9cb06a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9cb06a"]])

export default __exports__